import axios from "axios";
import { useSelector } from "react-redux";
import { baseURL } from "services/API";

const EINVOICING_BASE = `${baseURL}/einvoicing`;

const useEinvoicing = () => {
  const token = useSelector((state) => state.token);

  const authHeaders = () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  const getConfig = async () => {
    authHeaders();
    const response = await axios.get(`${EINVOICING_BASE}/config`);
    return response.data;
  };

  const updateConfig = async (payload) => {
    authHeaders();
    const response = await axios.put(`${EINVOICING_BASE}/config`, payload);
    return response.data;
  };

  const testConnection = async () => {
    authHeaders();
    const response = await axios.post(`${EINVOICING_BASE}/test-connection`);
    return response.data;
  };

  const refreshAesKey = async () => {
    authHeaders();
    const response = await axios.post(`${EINVOICING_BASE}/refresh-aes-key`);
    return response.data;
  };

  const syncGoods = async () => {
    authHeaders();
    const response = await axios.post(`${EINVOICING_BASE}/goods/sync`);
    return response.data;
  };

  const listInvoices = async () => {
    authHeaders();
    const response = await axios.get(`${EINVOICING_BASE}/invoices`);
    return response.data;
  };

  const issueInvoice = async (payload) => {
    authHeaders();
    const response = await axios.post(`${EINVOICING_BASE}/invoices`, payload);
    return response.data;
  };

  return {
    getConfig,
    updateConfig,
    testConnection,
    refreshAesKey,
    syncGoods,
    listInvoices,
    issueInvoice,
  };
};

export default useEinvoicing;
